<template>
    <v-container fluid class="mt-1">
        <v-row>
            <!-- Event Information Card -->
            <v-col cols="12" md="4">
                <v-card class="info-card" height="100%">
                    <div class="info-card-header pa-4 d-flex align-center">
                        <v-icon color="white" size="16" class="mr-2">mdi-calendar-text-outline</v-icon>
                        <span>Event Information</span>
                    </div>
                    <v-card-text class="pa-5">
                        <v-row dense>
                            <v-col cols="6">
                                <div class="info-item mb-0">
                                    <div class="info-label">ORGANISER</div>
                                    <div class="info-value">
                                        {{ event.lead.first_name + ' ' + (event.lead.last_name ?? '') }}
                                        <br>
                                        <v-chip x-small label v-if="event.lead.event_type"
                                            :color="event.lead.event_type.name === 'Hen' ? 'pink lighten-4' : event.lead.event_type.name === 'Birthday' ? 'green lighten-4' : event.lead.event_type.name === 'Party' ? 'orange lighten-4' : 'blue lighten-4'"
                                            :text-color="event.lead.event_type.name === 'Hen' ? 'pink darken-3' : event.lead.event_type.name === 'Birthday' ? 'green darken-3' : event.lead.event_type.name === 'Party' ? 'orange darken-3' : 'blue darken-3'">{{
                                                event.lead.event_type.name
                                            }} <label v-if="event.lead.event_type.name !== 'Party'"
                                                style="white-space:preserve;">
                                                Party</label>
                                        </v-chip>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="info-item mb-0">
                                    <div class="info-label">EVENT STATUS</div>
                                    <EventStatusSelect :value="event.event_status" @change="updateEventStatus"
                                        class="event-status-select mt-1" />
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="info-item">
                                    <div class="info-label">EVENT DATE</div>
                                    <div class="info-value">{{ $date(event.lead.start_date).format('dddd DD/MM/YYYY') }}
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="info-item">
                                    <div class="info-label">EVENT CODE</div>
                                    <div class="info-value">{{ event.reference_code }}</div>
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="info-item">
                                    <div class="info-label">EVENT PASSWORD</div>
                                    <div class="info-value">{{ event.password }}</div>
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="info-item">
                                    <div class="info-label">INVITEES ADDED</div>
                                    <div class="info-value">{{ event.invitees.length + 1 }} out of {{ event.lead.people
                                        }}
                                    </div>
                                </div>
                            </v-col>
                        </v-row>

                        <v-divider class="my-4"></v-divider>
                        <div class="section-label mb-3">Financial Summary</div>

                        <v-row dense>
                            <v-col cols="6">
                                <div class="info-item">
                                    <div class="info-label">
                                        PAID TO DATE
                                        <v-tooltip top max-width="260">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon small v-bind="attrs" v-on="on" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>Payments counted towards the quote balance (full payments, deposits and paid-in-full admin fees). Excludes contributions, bulk payments and processing fees — see the tiles below for those.</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="info-value" style="color:#27AE60;">{{ get_selected_company.currency }}{{
                                        paidToDate.toFixed(2)
                                    }}</div>
                                </div>
                            </v-col>
                            <!-- <v-col cols="6">
                                <div class="info-item">
                                    <div class="info-label">REFUND TO DATE</div>
                                    <div class="info-value">{{ get_selected_company.currency }}0</div>
                                </div>
                            </v-col> -->
                            <v-col cols="6">
                                <div class="info-item">
                                    <div class="info-label">
                                        TOTAL AMOUNT PAID
                                        <v-tooltip top max-width="260">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon small v-bind="attrs" v-on="on" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>Paid to Date plus Contributions and Bulk Payments — matches the sum of the Total Amount Paid column below. Includes paid-in-full admin fees, but excludes processing fees, which are shown separately under Fees.</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="info-value font-weight-bold">{{ get_selected_company.currency }}{{
                                        totalAmountPaid.toFixed(2) }}
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="info-item">
                                    <div class="info-label">CONTRIBUTIONS</div>
                                    <div class="d-flex align-center">
                                        <div class="info-value mr-2">{{ get_selected_company.currency }}{{
                                            totalContributions.toFixed(2) }}
                                        </div>
                                        <v-btn x-small outlined color="#3988AA" class="custom-buttons"
                                            style="padding:4px 8px!important;min-width:unset;height:24px;"
                                            @click="openAssignContributionsDialog()">Assign</v-btn>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="info-item">
                                    <div class="info-label">BULK PAYMENTS</div>
                                    <div class="d-flex align-center">
                                        <div class="info-value mr-2">{{ get_selected_company.currency }}{{
                                            totalBulkPayments.toFixed(2) }}
                                        </div>
                                        <v-btn x-small outlined color="#3988AA" class="custom-buttons"
                                            style="padding:4px 8px!important;min-width:unset;height:24px;"
                                            @click="openViewBulkPaymentsDialog()">View</v-btn>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="info-item">
                                    <div class="info-label">
                                        FEES
                                        <v-tooltip top max-width="260">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon small v-bind="attrs" v-on="on" class="ml-1">mdi-information-outline</v-icon>
                                            </template>
                                            <span>Processing and admin fees charged alongside payments, shown here for visibility. Paid-in-full admin fees are also counted within Paid to Date and Total Amount Paid; processing fees are not included in any other tile.</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="info-value">{{ get_selected_company.currency }}{{
                                        totalFees.toFixed(2) }}
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Management Card -->
            <v-col cols="12" md="3">
                <v-card class="info-card" height="100%">
                    <div class="info-card-header pa-4 d-flex align-center">
                        <v-icon color="white" size="16" class="mr-2">mdi-account-outline</v-icon>
                        <span>Management</span>
                    </div>
                    <v-card-text class="pa-5">
                        <v-row dense>
                            <v-col cols="12">
                                <div class="info-item">
                                    <div class="info-label mb-2">CONTRIBUTORS</div>
                                    <div v-if="!event.contributors || event.contributors.length === 0"
                                        class="info-value mb-2" style="color:grey;">
                                        No contributors added
                                    </div>
                                    <div v-for="contributor in sortedContributors" :key="contributor.id"
                                        class="d-flex align-center mb-2">
                                        <v-autocomplete :value="contributor.user_id"
                                            :items="contributorOptions(contributor)" :filter="filterContributorOptions"
                                            item-text="name" item-value="id" dense hide-details
                                            class="contributor-select" style="max-width:calc(100% - 32px);"
                                            @change="replaceEventContributor(contributor, $event)">
                                            <template v-slot:selection="{ item }">
                                                <span>{{ item.name }}</span>
                                                <v-chip small class="ml-2" color="#3988AA" text-color="white"
                                                    v-if="item.role">{{ item.role.name }}</v-chip>
                                            </template>
                                            <template v-slot:item="{ item }">
                                                <span>{{ item.name }}</span>
                                                <v-chip small class="ml-2" color="#3988AA" text-color="white"
                                                    v-if="item.role">{{ item.role.name }}</v-chip>
                                            </template>
                                        </v-autocomplete>
                                        <v-btn icon small class="ml-1" @click="deleteEventContributor(contributor)">
                                            <v-icon small color="error">mdi-delete-outline</v-icon>
                                        </v-btn>
                                    </div>
                                    <v-autocomplete v-if="availableContributorUsers.length"
                                        v-model="new_contributor_user_id" :items="availableContributorUsers"
                                        :filter="filterContributorOptions" item-text="name" item-value="id"
                                        placeholder="Add a contributor" dense hide-details
                                        class="contributor-select" @change="addEventContributor($event)">
                                        <template v-slot:selection="{ item }">
                                            <span>{{ item.name }}</span>
                                            <v-chip small class="ml-2" color="#3988AA" text-color="white"
                                                v-if="item.role">{{ item.role.name }}</v-chip>
                                        </template>
                                        <template v-slot:item="{ item }">
                                            <span>{{ item.name }}</span>
                                            <v-chip small class="ml-2" color="#3988AA" text-color="white"
                                                v-if="item.role">{{ item.role.name }}</v-chip>
                                        </template>
                                    </v-autocomplete>
                                </div>
                            </v-col>
                        </v-row>

                        <v-divider class="my-4"></v-divider>
                        <div class="section-label mb-3">Sign Up Link</div>

                        <v-textarea v-model="sign_up_link" readonly outlined rows="2" dense hide-details class="mb-3"
                            style="font-size:12px;"></v-textarea>
                        <v-btn small block color="#3988AA" dark elevation="0" class="custom-buttons"
                            @click="copyLinkV2()">
                            <v-icon small class="mr-2">mdi-content-copy</v-icon>
                            Copy Sign Up Link
                        </v-btn>
                        <v-btn small block outlined color="#3988AA" elevation="0" class="custom-buttons mt-2"
                            @click="openOrganiserDepositLinkDialog()">
                            <v-icon small class="mr-2">mdi-link-variant</v-icon>
                            Copy Organiser Deposit Link
                        </v-btn>

                        <v-divider class="my-4"></v-divider>
                        <div class="section-label mb-3">Login Link</div>

                        <v-text-field v-model="login_link" readonly outlined dense hide-details class="mb-3"
                            style="font-size:12px;"></v-text-field>
                        <v-btn small block color="#3988AA" dark elevation="0" class="custom-buttons"
                            @click="copyLoginLink()">
                            <v-icon small class="mr-2">mdi-content-copy</v-icon>
                            Copy Login Link
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Packages & Activity Card -->
            <v-col cols="12" md="5">
                <v-card class="info-card" height="100%">
                    <div class="info-card-header pa-4 d-flex align-center">
                        <v-icon color="white" size="16" class="mr-2">mdi-package-variant-closed</v-icon>
                        <span>Quotes &amp; Activity</span>
                    </div>
                    <v-card-text class="pa-5">
                        <div class="section-label mb-3">Quote Summary</div>
                        <div class="packages-list mb-2">
                            <div v-for="(quote, index) in event.quotes" :key="index" class="package-item">
                                <div class="package-name">
                                    {{ quote.name }}
                                    <v-chip small class="ml-2" color="#EEF2FF" style="color:#3988AA;font-weight:600;">
                                        {{ getGuestCountForQuote(quote) }} guests paid
                                    </v-chip>
                                </div>
                                <div><small class="mr-2">Quote Total:</small>
                                    <label class="package-price" style="color: #27AE60;">
                                        {{ get_selected_company.currency }}{{ quote.total }}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <v-divider class="mb-5"></v-divider>

                        <div class="d-flex align-center justify-space-between mb-3">
                            <div class="section-label">Notes</div>
                            <v-btn x-small outlined color="#3988AA" class="custom-buttons" @click="openNotesDialog()">
                                <v-icon x-small class="mr-1">mdi-plus</v-icon>
                                Add Note
                            </v-btn>
                        </div>
                        <div class="notes-container">
                            <div v-if="event.event_notes && event.event_notes.length === 0" class="no-notes">
                                No notes yet
                            </div>
                            <div v-for="note in event.event_notes" :key="note.id" class="note-item">
                                <div class="note-header">
                                    <div class="note-meta">
                                        <label class="note-date">
                                            {{ $date(note.created_at).format('DD/MM/YYYY HH:mm') }}
                                        </label>
                                        <label v-if="note.creator" class="note-author"> •
                                            {{ note.creator.name }}
                                        </label>
                                            <label class="note-author" style="color:#7F8C8D;font-weight:400;"> • {{ noteOrigin(note) }}</label>
                                    </div>
                                    <v-btn icon x-small @click="deleteEventNote(note)">
                                        <v-icon x-small color="error">mdi-delete-outline</v-icon>
                                    </v-btn>
                                </div>
                                <div class="note-content">{{ note.note_content }}</div>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="show_price_mismatches && priceMismatches.length" class="mt-5">
            <v-col cols="12" class="py-0">
                <v-alert type="warning" outlined dense class="mb-0">
                    What {{ priceMismatches.length === 1 ? 'this person has' : 'these people have' }} paid doesn't match
                    the package's current price. The quote was probably edited after they paid:
                    <strong>{{ priceMismatches.map(row => `${row.name} (${mismatchLabel(row.summary)})`).join(', ') }}</strong>.
                </v-alert>
            </v-col>
        </v-row>
        <v-row class="mt-5">
            <v-col cols="12" class="pt-0 custom-buttons">
                <div style="display:flex;">
                    <v-text-field label="Search within the table" prepend-inner-icon="mdi-magnify" outlined dense
                        style="max-width:400px;" v-model="search" class="mr-4"></v-text-field>
                    <v-spacer></v-spacer>
                    <!-- Price mismatch flags (paid in full but not the package's current price) are hidden until switched on -->
                    <v-checkbox v-model="show_price_mismatches" :label="priceMismatchLabel" dense hide-details
                        class="mt-0 pt-0 align-self-center"></v-checkbox>
                    <v-btn color="#3988AA" :dark="!locked" :disabled="locked" class="ml-5" @click="openAddInvitee()">
                        <v-icon class="mr-1" small>mdi-account-plus-outline</v-icon>
                        Add Invitee
                    </v-btn>
                    <v-btn color="#3988AA" :dark="!locked" :disabled="locked" class="ml-5" @click="openAddGuests()">
                        <v-icon class="mr-1" small>mdi-account-plus-outline</v-icon>
                        Add Guests
                    </v-btn>
                    <!-- <v-btn color="#F7F7F7" class="mr-5"><v-icon class="mr-1" small>mdi-credit-card-outline</v-icon>Pay an
                    Invitee</v-btn> -->
                    <!-- <v-btn color="#F7F7F7" class="mr-5"><v-icon class="mr-1" small>mdi-credit-card-outline</v-icon>Pay
                    Guestlist</v-btn> -->
                    <!-- <v-btn @click="openMarkInviteesAsPaidDialog()" color="#F7F7F7" class="mr-5"
                    :disabled="checked_invitees.length > 0 ? false : true">
                    <v-icon class="mr-1" small>mdi-check-circle-outline</v-icon>Mark as Paid
                </v-btn> -->
                    <!-- <v-menu right bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mr-5" dark v-bind="attrs" v-on="on">
                                Actions<v-icon class="ml-1" small>mdi-chevron-down</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-if="checked_invitees.length > 0" @click="openDeleteInviteesDialog()">
                                <v-list-item-title style="cursor:pointer;">
                                    Delete Invitees
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item v-else>
                                <v-list-item-title style="color:lightgrey;">
                                    Delete Invitees
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu> -->
                    <br>
                    <div class="mr-5 mt-10" v-if="checked_invitees.length > 0">
                        {{ checked_invitees.length }} invitees selected
                    </div>
                    <!-- <v-btn class="custom-buttons mr-3"><v-icon class="mr-2">mdi-filter-outline</v-icon>Filter</v-btn> -->
                    <!-- <v-btn class="custom-buttons mr-3"><v-icon class="mr-2">mdi-refresh</v-icon>Reset</v-btn> -->
                    <!-- <v-btn class="custom-buttons" dark><v-icon class="mr-2">mdi-tray-arrow-down</v-icon>Export</v-btn> -->
                </div>
                <v-card outlined class="card-format" style="margin-bottom:50px;">
                    <v-data-table :headers="headers" :items="event.invitees" :search="search" disable-pagination
                        hide-default-footer :items-per-page="-1">
                        <!-- <template v-slot:header.checkbox="{ }">
                            <input v-if="event.invitees.length > 0" type="checkbox" :checked="checked_all_invitees"
                                @click="checkAllInvitees()" style="cursor:pointer;">
                        </template> -->
                        <template slot="no-data">
                        </template>
                        <template v-slot:body.prepend>
                            <!-- <tr style="font-weight:600;cursor:initial;background-color: #EFFAFF;"
                                :set1="org_deposit_payment = event.lead.payments.filter((item) => item.status == 'Organizer Deposit')[0]"
                                :set2="org_package_payment = event.lead.payments.filter((item) => item.status == 'Organizer Payment')[0]"
                                :class="event.lead.payments.filter((item) => item.status == 'Organizer Payment')[0] ? 'paid_row' : 'unpaid_row'"> -->
                            <tr style="font-weight:600;cursor:initial;background-color: #EFFAFF;"
                                :class="getOrganizerStatus() === 'Paid in Full' ? 'paid_row' : 'unpaid_row'">
                                <!-- <td>
                                    <input type="checkbox"
                                        :checked="checked_invitees.findIndex((items) => items.id == item.id) > -1 ? true : false"
                                        @click="checkInvitee(item)" style="cursor:pointer;">
                                </td> -->
                                <td>
                                    {{ event.lead.first_name + ' ' + (event.lead.last_name ?? '') }}
                                    <br>
                                    <v-chip color="#3988AA" x-small outlined>
                                        <label style="font-weight:400!important;font-size:12px!important;">
                                            Organiser
                                        </label>
                                    </v-chip>
                                </td>
                                <td>
                                    {{ event.lead.email }}
                                    <br>
                                    <small style="color:#3988AA;">{{ event.lead.mobile }}</small>
                                </td>
                                <td style="text-align:center;">
                                    <label>
                                        {{ get_selected_company.currency }}{{ getOrganizerTotal().toFixed(2) }}
                                    </label>
                                    <br>
                                    <v-btn text x-small style="font-weight:300!important;color:#3988AA;"
                                        @click="openViewPaymentsDialog(event.lead, 'lead')">
                                        <label style="font-size:12px;cursor: pointer;">View</label>
                                    </v-btn>
                                </td>
                                <td>
                                    <div v-if="getOrganizerPaymentDates().fullPaymentDate">
                                        Paid in Full:
                                        <label style="font-weight:400!important;">
                                            {{ $date(getOrganizerPaymentDates().fullPaymentDate).format('DD/MM/YYYY')
                                            }}
                                        </label>
                                    </div>
                                    <div v-if="getOrganizerPaymentDates().depositDate">
                                        Deposit:
                                        <label style="font-weight:400!important;">
                                            {{ $date(getOrganizerPaymentDates().depositDate).format('DD/MM/YYYY') }}
                                        </label>
                                    </div>
                                </td>
                                <td>
                                    {{ getOrganizerStatus() }}
                                    <v-tooltip v-if="show_price_mismatches && getOrganizerSummary().mismatch" bottom color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <div class="price-mismatch" v-bind="attrs" v-on="on">
                                                <v-icon x-small color="#E65100">mdi-alert</v-icon>
                                                {{ mismatchLabel(getOrganizerSummary()) }}
                                            </div>
                                        </template>
                                        <span>{{ mismatchTooltip(getOrganizerSummary()) }}</span>
                                    </v-tooltip>
                                </td>
                                <!-- <td>
                                    <span style="font-weight:300!important;color:grey;">N/A</span>
                                </td> -->
                                <td>
                                    <div v-if="getOrganizerPackage()">
                                        {{ getOrganizerPackage() }}
                                    </div>
                                </td>
                                <!-- <td>{{ event.lead.paid_by }}</td> -->
                                <td style="text-align:right;">
                                    <v-tooltip bottom color="primary" v-if="getOrganizerStatus() !== 'Paid in Full'">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn small dense icon v-bind="attrs" v-on="on" :disabled="locked"
                                                @click="openPayOrganiserDialog()">
                                                <v-icon color="black">mdi-credit-card-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Add a Payment</span>
                                    </v-tooltip>

                                    <v-menu right bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn small dense icon v-bind="attrs" v-on="on">
                                                <v-icon color="black">mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list dense>
                                            <v-subheader>Email Organiser</v-subheader>
                                            <v-list-item style="cursor:pointer;" @click="organiser_email_dialog = true">
                                                <v-list-item-title>
                                                    Login Details
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item style="cursor:pointer;"
                                                @click="organiser_itinerary_dialog = true">
                                                <v-list-item-title>
                                                    Itinerary
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item style="cursor:pointer;"
                                                @click="organiser_balance_due_dialog = true">
                                                <v-list-item-title>
                                                    Balance Due Reminder
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item style="cursor:pointer;"
                                                @click="organiser_deposits_reminder_dialog = true">
                                                <v-list-item-title>
                                                    Per Person Deposits Reminder
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item style="cursor:pointer;"
                                                @click="show_final_guestlist_dialog = true">
                                                <v-list-item-title>
                                                    Final Guest List
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item style="cursor:pointer;"
                                                @click="organiser_payment_summary_dialog = true">
                                                <v-list-item-title>
                                                    Payment Summary
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-divider></v-divider>
                                            <v-list-item v-if="getOrganizerStatus() !== 'Paid in Full'" :disabled="locked"
                                                style="cursor:pointer;" @click="organiser_paid_confirm = { show: true, undo: false, loading: false }">
                                                <v-list-item-title>Mark as Paid in Full (No Payment)</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item v-if="getOrganizerManualMarkPaidPayment()" :disabled="locked"
                                                style="cursor:pointer;" @click="organiser_paid_confirm = { show: true, undo: true, loading: false }">
                                                <v-list-item-title>Mark as Unpaid</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                        </template>

                        <template v-slot:item="{ item }">
                            <tr style="font-weight:600;cursor:initial;background-color: #EFFAFF;"
                                :class="getInviteeStatus(item) === 'Paid in Full' ? 'paid_row' : 'unpaid_row'">
                                <!-- <td>
                                    <input v-if="!inv_package_payment" type="checkbox"
                                        :checked="checked_invitees.findIndex((items) => items.id == item.id) > -1 ? true : false"
                                        @click="checkInvitee(item)" style="cursor:pointer;">
                                </td> -->
                                <td>
                                    {{ item.name }}<br>
                                    <v-chip color="#3988AA" x-small outlined>
                                        <label style="font-weight:400!important;font-size:12px!important;">
                                            {{ item.id === stagHenInviteeId ? 'Stag/Hen' : 'Invitee' }}
                                        </label>
                                    </v-chip>
                                    <v-chip v-if="rsvpOf(item)" x-small outlined class="ml-1"
                                        :color="rsvpOf(item) === 'declined' ? '#C62828' : '#2E7D32'"
                                        :title="item.rsvp_status && item.rsvp_at ? `Answered ${$date(item.rsvp_at).format('DD/MM/YYYY HH:mm')}` : 'From payment'">
                                        <label style="font-weight:400!important;font-size:12px!important;">
                                            {{ rsvpOf(item) === 'declined' ? 'Not coming' : 'Coming' }}
                                        </label>
                                    </v-chip>
                                </td>
                                <td>
                                    {{ item.email }}<br><small style="color:#3988AA;">{{ item.mobile }}</small>
                                </td>
                                <td style="text-align:center;">
                                    <label>
                                        {{ get_selected_company.currency }}{{ getInviteeTotal(item).toFixed(2) }}
                                    </label>
                                    <br>
                                    <v-btn text small style="font-weight:300!important;color:#3988AA;"
                                        @click="openViewPaymentsDialog(item, 'invitee')">
                                        <label style="font-size:12px;cursor: pointer;">View</label>
                                    </v-btn>
                                </td>
                                <td>
                                    <div v-if="getInviteePaymentDates(item).fullPaymentDate">
                                        Paid in Full:
                                        <label style="font-weight:400!important;">
                                            {{ $date(getInviteePaymentDates(item).fullPaymentDate).format('DD/MM/YYYY')
                                            }}
                                        </label>
                                    </div>
                                    <div v-if="getInviteePaymentDates(item).depositDate">
                                        Deposit:
                                        <label style="font-weight:400!important;">
                                            {{ $date(getInviteePaymentDates(item).depositDate).format('DD/MM/YYYY') }}
                                        </label>
                                    </div>
                                </td>
                                <td>
                                    {{ getInviteeStatus(item) }}
                                    <v-tooltip v-if="show_price_mismatches && getInviteeSummary(item).mismatch" bottom color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <div class="price-mismatch" v-bind="attrs" v-on="on">
                                                <v-icon x-small color="#E65100">mdi-alert</v-icon>
                                                {{ mismatchLabel(getInviteeSummary(item)) }}
                                            </div>
                                        </template>
                                        <span>{{ mismatchTooltip(getInviteeSummary(item)) }}</span>
                                    </v-tooltip>
                                </td>
                                <!-- <td>
                                    <label v-if="item.deposit_paid" small>Yes</label>
                                    <label v-else small>No</label>
                                </td> -->
                                <td>
                                    <div v-if="getInviteePackage(item)">
                                        {{ getInviteePackage(item) }}
                                    </div>
                                </td>
                                <!-- <td>{{ item.paid_by }}</td> -->
                                <td style="text-align:right;">
                                    <v-tooltip bottom color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn small dense icon v-bind="attrs" v-on="on" :disabled="locked"
                                                @click="openMarkInviteeAsPaidDialog(item)">
                                                <v-icon color="black">mdi-credit-card-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Add a Payment</span>
                                    </v-tooltip>
                                    <v-tooltip bottom color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn small dense icon v-bind="attrs" v-on="on" :disabled="locked"
                                                @click="openUpdateInviteeDialog(item)">
                                                <v-icon color="black">mdi-pencil-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Update Invitee</span>
                                    </v-tooltip>
                                    <v-tooltip bottom color="primary" v-if="!hasRealPayments(item)">

                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn small dense icon v-bind="attrs" v-on="on" :disabled="locked"
                                                @click="openDeleteInviteeDialog(item)">
                                                <v-icon color="black">mdi-delete-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Delete Invitee</span>
                                    </v-tooltip>
                                    <v-menu right bottom>

                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn small dense icon v-bind="attrs" v-on="on">
                                                <v-icon color="black">mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item style="cursor:pointer;"
                                                @click="openConfirmSendInviteeEmail(item)">
                                                <v-list-item-title>
                                                    Send Invitee Login Details
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item v-if="getInviteeStatus(item) !== 'Paid in Full'"
                                                :disabled="locked" style="cursor:pointer;" @click="openMarkPaidDialog(item)">
                                                <v-list-item-title>
                                                    Mark as Paid (No Payment)
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item v-if="getManualMarkPaidPayment(item)"
                                                :disabled="locked" style="cursor:pointer;" @click="openMarkUnpaidDialog(item)">
                                                <v-list-item-title>
                                                    Mark as Unpaid
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item v-if="item.rsvp_status !== 'declined'"
                                                :disabled="locked" style="cursor:pointer;" @click="setRsvp(item, 'declined')">
                                                <v-list-item-title>Mark as Not Coming</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item v-if="item.rsvp_status !== 'attending'"
                                                :disabled="locked" style="cursor:pointer;" @click="setRsvp(item, 'attending')">
                                                <v-list-item-title>Mark as Coming</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item v-if="item.rsvp_status"
                                                :disabled="locked" style="cursor:pointer;" @click="setRsvp(item, null)">
                                                <v-list-item-title>Clear RSVP</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item v-if="item.id !== stagHenInviteeId"
                                                :disabled="locked" style="cursor:pointer;" @click="setStagHen(item)">
                                                <v-list-item-title>Set as Stag/Hen</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-dialog v-model="notes_dialog" max-width="800px" persistent>
                <v-card>
                    <v-card-title>Add Note</v-card-title>
                    <v-card-text>
                        <v-textarea v-model="new_note_content" outlined dense placeholder="Add a note..." hide-details
                            auto-grow rows="4"></v-textarea>
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-btn text @click="closeNotesDialog()">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn dark @click="createEventNote()" :disabled="!new_note_content">Create Note</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="add_invitee_dialog" max-width="500px" persistent>
                <v-card>
                    <v-card-title>
                        Add Invitee
                    </v-card-title>
                    <v-card-text>
                        <div style="display:flex;justify-content:space-between;">
                            <b>Name</b><v-text-field label="Name" style="max-width:75%;" dense outlined
                                v-model="new_invitee.name"></v-text-field>
                        </div>
                        <div style="display:flex;justify-content:space-between;">
                            <b>Email</b><v-text-field label="Email" style="max-width:75%;" dense outlined
                                v-model="new_invitee.email"></v-text-field>
                        </div>
                        <div style="display:flex;justify-content:space-between;">
                            <b>Mobile</b><v-text-field label="Mobile" type="tel" style="max-width:75%;" dense
                                outlined v-model="new_invitee.mobile"></v-text-field>
                        </div>
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeAddInvitee()">Cancel</v-btn>
                        <v-btn dark @click="addInvitee()">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="update_invitee_dialog" max-width="500px" persistent>
                <v-card>
                    <v-card-title>
                        Update Invitee
                    </v-card-title>
                    <v-card-text>
                        <div style="display:flex;justify-content:space-between;">
                            <b>Name</b><v-text-field label="Name" style="max-width:75%;" dense outlined
                                v-model="invitee_to_update.name"></v-text-field>
                        </div>
                        <div style="display:flex;justify-content:space-between;">
                            <b>Email</b><v-text-field label="Email" style="max-width:75%;" dense outlined
                                v-model="invitee_to_update.email"></v-text-field>
                        </div>
                        <div style="display:flex;justify-content:space-between;">
                            <b>Mobile</b><v-text-field label="Mobile" type="tel" style="max-width:75%;" dense
                                outlined v-model="invitee_to_update.mobile"></v-text-field>
                        </div>
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeUpdateInviteeDialog()">Cancel</v-btn>
                        <v-btn dark @click="updateInvitee()">Update</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="add_guests_dialog" max-width="500px" persistent>
                <v-card>
                    <v-card-title>
                        Add Invitee
                    </v-card-title>
                    <v-card-text>
                        <div style="display:flex;justify-content:space-between;">
                            <b>Guests *</b><v-text-field label="Number of Guests *" type="number" style="max-width:75%;"
                                dense outlined v-model="guestlist.number"></v-text-field>
                        </div>
                        <div style="display:flex;justify-content:space-between;">
                            <b>Package *</b><v-select label="Package *"
                                :items="[{ name: 'Unpaid Guest', id: 0 }, ...event.quotes]" :item-text="'name'"
                                :item-value="'id'" style="max-width:75%;" dense outlined
                                v-model="guestlist.quote"></v-select>
                        </div>
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeAddGuests()">Cancel</v-btn>
                        <v-btn dark @click="addGuests()">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row v-if="invitee_to_delete">
            <v-dialog v-model="delete_invitee_dialog" max-width="500px" persistent>
                <v-card>
                    <v-card-title>
                        Delete Invitee
                    </v-card-title>
                    <v-card-text>
                        Are you sure you want to delete {{ invitee_to_delete.name }}?
                        <v-text-field v-model="confirmation"
                            placeholder="Please type 'DELETE' to confirm"></v-text-field>
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeDeleteInviteeDialog()">Cancel</v-btn>
                        <v-btn :dark="confirmation == 'DELETE'" @click="deleteInvitee()"
                            :disabled="confirmation != 'DELETE'">Delete</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row v-if="invitees_to_delete">
            <v-dialog v-model="delete_invitees_dialog" max-width="500px" persistent>
                <v-card>
                    <v-card-title>
                        Delete Invitee(s)
                    </v-card-title>
                    <v-card-text>
                        Are you sure you want to delete the following invitees?
                        <label v-for="(invitee, index) in invitees_to_delete" :key="index"><br>{{ invitee.name
                            }}</label>
                        <v-text-field v-model="confirmation"
                            placeholder="Please type 'DELETE' to confirm"></v-text-field>
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeDeleteInviteesDialog()">Cancel</v-btn>
                        <v-btn :dark="confirmation == 'DELETE'" @click="deleteInvitees()"
                            :disabled="confirmation != 'DELETE'">Delete</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- <v-row>
            <v-dialog v-model="mark_invitees_as_paid_dialog" max-width="500px" persistent>
                <v-card>
                    <v-card-title>
                        Mark Invitees as Paid
                    </v-card-title>
                    <v-card-text>
                        <label v-for="(invitee, index) in checked_invitees" :key="index">{{ invitee.name }}<br></label>
                        <br>
                        <div style="display:flex;justify-content:space-between;">
                            <b>Package *</b><v-select label="Package *" :items="event.quotes" :item-text="'name'"
                                :item-value="'id'" style="max-width:75%;" dense outlined v-model="selected_quote"
                                return-object></v-select>
                        </div>
                        <v-text-field v-model="reference_code" label="Reference Code *" dense outlined></v-text-field>
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeMarkInviteesAsPaidDialog()">Cancel</v-btn>
                        <v-btn dark @click="markInviteesAsPaid()">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row> -->
        <v-row>
            <v-dialog v-model="mark_invitee_as_paid_dialog" max-width="500px" persistent>
                <v-card v-if="selected_invitee">
                    <v-card-title>
                        Add a Payment for {{ selected_invitee.name }}
                    </v-card-title>
                    <v-card-text>
                        <v-select label="Package *" :items="[{ name: 'None', value: 0 }, ...event.quotes]"
                            :item-text="'name'" :item-value="'id'" dense outlined v-model="selected_quote"
                            return-object></v-select>
                        <v-select v-model="selected_payment_type"
                            :items="payment_types.filter(t => [2, 1].includes(t.id)).sort((a, b) => (b.id === 2) - (a.id === 2))"
                            :item-text="'type'" :item-value="'id'" label="Payment Type *" dense outlined
                            return-object></v-select>
                        <v-text-field v-model="custom_amount" type="number" label="Amount *" dense
                            outlined></v-text-field>
                        <v-text-field v-model="reference_code" label="Reference Code *" dense outlined></v-text-field>
                        <v-select v-model="selected_payment_gateway" :items="['Stripe', 'Sagepay', 'Authipay']"
                            return-object label="Payment Gateway *" dense outlined></v-select>
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeMarkInviteeAsPaidDialog()">Cancel</v-btn>
                        <v-btn dark @click="markInviteeAsPaid()">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row v-if="invitee_to_mark_paid">
            <v-dialog v-model="mark_paid_dialog" max-width="450px" persistent>
                <v-card>
                    <v-card-title>
                        Mark {{ invitee_to_mark_paid.name }} as Paid
                    </v-card-title>
                    <v-card-text>
                        This marks {{ invitee_to_mark_paid.name }} as Paid in Full without recording any payment
                        amount — use this for comped/free guests. They'll no longer show as owing a deposit.
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeMarkPaidDialog()">Cancel</v-btn>
                        <v-btn dark color="#3988AA" @click="confirmMarkPaid()">Mark as Paid</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="organiser_paid_confirm.show" max-width="450px" persistent>
                <v-card>
                    <v-card-title>
                        Mark {{ event.lead.first_name }} {{ event.lead.last_name }} as
                        {{ organiser_paid_confirm.undo ? 'Unpaid' : 'Paid in Full' }}
                    </v-card-title>
                    <v-card-text v-if="!organiser_paid_confirm.undo">
                        Use this when the organiser was given a discount on their own place (e.g. £50 off the
                        organiser, agreed case by case), so what they paid is less than the package. They'll show
                        as Paid in Full here and in the organiser portal, and won't count as a price mismatch. Their
                        payments stay as they are; no payment is recorded.
                    </v-card-text>
                    <v-card-text v-else>
                        This removes the "Paid in Full (No Payment)" mark. The organiser's status goes back to
                        reflecting what they've actually paid.
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-spacer></v-spacer>
                        <v-btn text :disabled="organiser_paid_confirm.loading"
                            @click="organiser_paid_confirm = { show: false, undo: false, loading: false }">Cancel</v-btn>
                        <v-btn dark color="#3988AA" :loading="organiser_paid_confirm.loading"
                            @click="organiser_paid_confirm.undo ? confirmOrganiserMarkUnpaid() : confirmOrganiserMarkPaid()">
                            {{ organiser_paid_confirm.undo ? 'Mark as Unpaid' : 'Mark as Paid' }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row v-if="invitee_to_mark_unpaid">
            <v-dialog v-model="mark_unpaid_dialog" max-width="450px" persistent>
                <v-card>
                    <v-card-title>
                        Mark {{ invitee_to_mark_unpaid.name }} as Unpaid
                    </v-card-title>
                    <v-card-text>
                        This removes the manual "Marked as Paid" record for {{ invitee_to_mark_unpaid.name }}. Their
                        payment status will revert to reflect any actual payments made.
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeMarkUnpaidDialog()">Cancel</v-btn>
                        <v-btn dark color="#3988AA" @click="confirmMarkUnpaid()">Mark as Unpaid</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="pay_organiser_dialog" max-width="500px" persistent>
                <v-card>
                    <v-card-title>
                        Add a Payment for {{ event.lead.first_name }} {{ event.lead.last_name }}
                    </v-card-title>
                    <v-card-text>
                        <v-select label="Package *" :items="[{ name: 'None', value: 0 }, ...event.quotes]"
                            :item-text="'name'" :item-value="'id'" dense outlined v-model="selected_quote"
                            return-object></v-select>
                        <v-select v-model="selected_payment_type"
                            :items="payment_types.filter(t => [2, 1].includes(t.id)).sort((a, b) => (b.id === 2) - (a.id === 2))"
                            :item-text="'type'" :item-value="'id'" label="Payment Type *" dense outlined
                            return-object></v-select>
                        <v-text-field v-model="custom_amount" type="number" label="Amount *" dense
                            outlined></v-text-field>
                        <v-text-field v-model="reference_code" label="Reference Code *" dense outlined></v-text-field>
                        <v-select v-model="selected_payment_gateway" :items="['Stripe', 'Sagepay', 'Authipay']"
                            return-object label="Payment Gateway *" dense outlined></v-select>
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-spacer></v-spacer>
                        <v-btn text @click="closePayOrganiserDialog()">Cancel</v-btn>
                        <v-btn dark @click="markOrganiserAsPaid()">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="view_payments_dialog" max-width="1000px" persistent>
                <v-card v-if="view_payments_target">
                    <v-card-title class="text-subtitle-1 font-weight-bold pb-1">
                        Payments &ndash; {{ view_payments_target.name || (view_payments_target.first_name + ' ' +
                            view_payments_target.last_name) }}
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-4" style="max-height: 65vh; overflow-y: auto;">
                        <div class="section-label mb-2">Payments Made Towards
                            {{ view_payments_target.name || (view_payments_target.first_name + ' ' +
                                view_payments_target.last_name) }}</div>

                        <v-row>
                            <v-col cols="4" v-for="(card, card_index) in payments_towards_user"
                                :key="'user-' + card_index">
                                <v-card outlined class="mb-3 payment-detail-card">
                                    <v-card-text class="pb-2">
                                        <div class="d-flex justify-space-between align-start">
                                            <div>
                                                <div class="font-weight-medium">
                                                    {{ $date(card.payment.payment_date).format('DD/MM/YYYY, HH:mm') }}
                                                </div>
                                                <div class="caption label-text-color">Paid by {{ card.paidBy }}</div>
                                            </div>
                                            <div class="text-right font-weight-bold" style="font-size: 16px;">
                                                {{ get_selected_company.currency }}{{ getCardTotal(card).toFixed(2) }}
                                            </div>
                                        </div>
                                        <v-divider class="my-2"></v-divider>
                                        <div v-for="(row, row_index) in card.rows" :key="row_index"
                                            class="payment-detail-row d-flex justify-space-between align-center">
                                            <div>
                                                <span>{{ row.label }}</span>
                                                <span v-if="row.quote" class="label-text-color"> &middot; {{ row.quote
                                                    }}</span>
                                            </div>
                                            <div class="d-flex align-center">
                                                <span class="mr-2">{{ get_selected_company.currency }}{{
                                                    Number(row.amount).toFixed(2) }}</span>
                                                <v-btn icon x-small color="red" :disabled="locked"
                                                    @click="askDeleteViewedPaymentDetail(card, row, 'towards_user')">
                                                    <v-icon x-small>mdi-delete</v-icon>
                                                </v-btn>
                                            </div>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <div v-if="!payments_towards_user.length" class="text-center label-text-color py-4">
                            No payments recorded yet
                        </div>

                        <div class="section-label mb-2 mt-6">Payments Made Towards Other Users</div>

                        <v-row>
                            <v-col cols="4" v-for="(card, card_index) in payments_towards_others"
                                :key="'others-' + card_index">
                                <v-card outlined class="mb-3 payment-detail-card">
                                    <v-card-text class="pb-2">
                                        <div class="d-flex justify-space-between align-start">
                                            <div>
                                                <div class="font-weight-medium">
                                                    {{ $date(card.payment.payment_date).format('DD/MM/YYYY, HH: mm') }}
                                                </div>
                                                <div class="caption label-text-color">Towards {{ card.paidTowards }}
                                                </div>
                                            </div>
                                            <div class="text-right font-weight-bold" style="font-size: 16px;">
                                                {{ get_selected_company.currency }}{{ getCardTotal(card).toFixed(2) }}
                                            </div>
                                        </div>
                                        <v-divider class="my-2"></v-divider>
                                        <div v-for="(row, row_index) in card.rows" :key="row_index"
                                            class="payment-detail-row d-flex justify-space-between align-center">
                                            <span>{{ row.label }}</span>
                                            <div class="d-flex align-center">
                                                <span class="mr-2">{{ get_selected_company.currency }}{{
                                                    Number(row.amount).toFixed(2)
                                                }}</span>
                                                <v-btn icon x-small color="red" :disabled="locked"
                                                    @click="askDeleteViewedPaymentDetail(card, row, 'towards_others')">
                                                    <v-icon x-small>mdi-delete</v-icon>
                                                </v-btn>
                                            </div>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <div v-if="!payments_towards_others.length" class="text-center label-text-color py-4">
                            No payments recorded yet
                        </div>
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeViewPaymentsDialog()">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="assign_contributions_dialog" max-width="900px" persistent>
                <v-card>
                    <v-card-title>Assign Contributions</v-card-title>
                    <v-card-subtitle>Assign each contribution to the lead or an invitee. Clear the selection to leave it
                        unassigned. If the payer meant it for their own place, use
                        <v-icon small>mdi-swap-horizontal</v-icon> to make it their deposit or full
                        payment.</v-card-subtitle>
                    <v-divider></v-divider>
                    <v-card-text class="pt-4">
                        <v-data-table :headers="contributionHeaders" :items="allContributions" disable-pagination
                            hide-default-footer>
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td>{{ item.paid_by_name }}</td>
                                    <td>{{ item.payment_date }}</td>
                                    <td>{{ get_selected_company.currency }}{{ Number(item.amount).toFixed(2) }}</td>
                                    <td style="min-width:260px;padding:8px 16px;">
                                        <v-autocomplete :value="item.paid_to" :items="assignablePersons"
                                            item-text="label" item-value="id" placeholder="Unassigned" clearable dense
                                            outlined hide-details :disabled="locked"
                                            @change="assignContribution(item.id, $event)"></v-autocomplete>
                                    </td>
                                    <td style="white-space:nowrap;">
                                        <v-tooltip bottom color="primary">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon small v-bind="attrs" v-on="on" :disabled="locked"
                                                    @click="openConvertContribution(item)">
                                                    <v-icon small>mdi-swap-horizontal</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Make it {{ item.paid_by_name }}'s own deposit or full payment</span>
                                        </v-tooltip>
                                        <v-btn v-if="get_user.id == 1" icon x-small color="red" :disabled="locked"
                                            @click="askDeleteContribution(item)">
                                            <v-icon x-small>mdi-delete</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                            <template v-slot:no-data>
                                <div class="text-center py-4 grey--text">No contributions found for this event.</div>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeAssignContributionsDialog()">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="delete_confirm.show" max-width="480px" persistent>
                <v-card>
                    <v-card-title>{{ delete_confirm.title }}</v-card-title>
                    <v-card-text>
                        <div>{{ delete_confirm.message }}</div>
                        <div class="mt-2 label-text-color">This can't be undone.</div>
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-spacer></v-spacer>
                        <v-btn text :disabled="delete_confirm.loading" @click="closeDeleteConfirm()">Cancel</v-btn>
                        <v-btn color="#E53935" class="white--text" :loading="delete_confirm.loading"
                            @click="runDeleteConfirm()">
                            <v-icon small left>mdi-delete</v-icon>
                            Delete
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="convert_contribution.show" max-width="480px" persistent>
                <v-card v-if="convert_contribution.item">
                    <v-card-title>Change to {{ convert_contribution.item.paid_by_name }}'s own payment</v-card-title>
                    <v-card-text>
                        <div class="mb-4">
                            The {{ get_selected_company.currency }}{{ Number(convert_contribution.item.amount).toFixed(2) }}
                            contribution {{ convert_contribution.item.paid_by_name }} paid on
                            {{ convert_contribution.item.payment_date }} (now assigned to
                            {{ convert_contribution.item.paid_to == null ? 'nobody' : getPersonLabel(convert_contribution.item.paid_to) }})
                            becomes their own payment. It stays on the same card payment, so its reference is kept.
                        </div>
                        <v-radio-group v-model="convert_contribution.payment_type_id" dense hide-details class="mt-0">
                            <v-radio label="Deposit" :value="2"></v-radio>
                            <v-radio label="Full Payment" :value="1"></v-radio>
                        </v-radio-group>
                        <v-select v-if="convert_contribution.payment_type_id === 1" v-model="convert_contribution.quote_id"
                            :items="event.quotes" item-text="name" item-value="id" label="Package *" dense outlined
                            hide-details class="mt-4"></v-select>
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-spacer></v-spacer>
                        <v-btn text :disabled="convert_contribution.loading" @click="closeConvertContribution()">Cancel</v-btn>
                        <v-btn dark color="#3988AA" :loading="convert_contribution.loading"
                            :disabled="convert_contribution.payment_type_id === 1 && !convert_contribution.quote_id"
                            @click="convertContribution()">Change</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="view_bulk_payments_dialog" max-width="900px" persistent>
                <v-card>
                    <v-card-title>Bulk Payments</v-card-title>
                    <v-card-subtitle>All bulk payments made for this event.</v-card-subtitle>
                    <v-divider></v-divider>
                    <v-card-text class="pt-4">
                        <v-data-table :headers="bulk_payment_headers" :items="allBulkPayments" disable-pagination
                            hide-default-footer>
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td>{{ item.paid_by_name }}</td>
                                    <td>{{ $date(item.payment_date).format('DD/MM/YYYY') }}</td>
                                    <td>{{ get_selected_company.currency }}{{ Number(item.amount).toFixed(2) }}</td>
                                    <td style="white-space:normal;min-width:260px;">{{ item.notes }}</td>
                                </tr>
                            </template>
                            <template v-slot:no-data>
                                <div class="text-center py-4 grey--text">No bulk payments found for this event.</div>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeViewBulkPaymentsDialog()">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- organiser deposit link dialog -->
        <v-row>
            <v-dialog v-model="organiser_deposit_link_dialog" max-width="520px" persistent>
                <v-card>
                    <v-card-title>Organiser Deposit Link</v-card-title>
                    <v-card-subtitle>Select a quote to generate the deposit payment link.</v-card-subtitle>
                    <v-divider></v-divider>
                    <v-card-text class="pt-4">
                        <v-select v-model="selected_deposit_quote" :items="event.quotes" item-value="id"
                            label="Select Quote *" dense outlined return-object clearable>
                            <template v-slot:item="{ item }">
                                <div class="d-flex justify-space-between align-center" style="width:100%;">
                                    <span>{{ item.name }}</span>
                                    <span class="ml-4" style="color:#27AE60;font-weight:700;">{{
                                        get_selected_company.currency }}{{ item.total }}</span>
                                </div>
                            </template>
                            <template v-slot:selection="{ item }">
                                <div class="d-flex align-center">
                                    <span>{{ item.name }}</span>
                                    <span class="ml-3" style="color:#27AE60;font-weight:700;">{{
                                        get_selected_company.currency }}{{ item.total }}</span>
                                </div>
                            </template>
                        </v-select>
                        <v-textarea :value="organiserDepositLink" readonly outlined rows="2" dense hide-details
                            label="Link Preview"
                            :placeholder="selected_deposit_quote ? '' : 'Select a quote above to preview the link'"
                            style="font-size:12px;"></v-textarea>
                    </v-card-text>
                    <v-card-actions class="custom-buttons">
                        <v-btn text @click="closeOrganiserDepositLinkDialog()">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn dark color="#3988AA" :disabled="!selected_deposit_quote"
                            @click="copyOrganiserDepositLink()">
                            <v-icon small class="mr-2">mdi-content-copy</v-icon>
                            Copy Link
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <PreviewInviteeEmail :show="confirmationSendInvEmail" :invitee="invitee_to_email || {}" :event="event"
            :company_id="get_selected_company.id" @close="confirmationSendInvEmail = false; invitee_to_email = null">
        </PreviewInviteeEmail>
        <PreviewOrganiserEmail :show="organiser_email_dialog" :lead="event.lead" :event="event"
            :company_id="get_selected_company.id" @close="organiser_email_dialog = false"></PreviewOrganiserEmail>
        <PreviewOrganiserItineraryEmail :show="organiser_itinerary_dialog" :lead="event.lead" :event="event"
            :company_id="get_selected_company.id" @close="organiser_itinerary_dialog = false">
        </PreviewOrganiserItineraryEmail>
        <PreviewOrganiserBalanceDueEmail :show="organiser_balance_due_dialog" :lead="event.lead" :event="event"
            :company_id="get_selected_company.id" @close="organiser_balance_due_dialog = false">
        </PreviewOrganiserBalanceDueEmail>
        <PreviewOrganiserDepositsReminderEmail :show="organiser_deposits_reminder_dialog" :lead="event.lead"
            :event="event" :company_id="get_selected_company.id" @close="organiser_deposits_reminder_dialog = false">
        </PreviewOrganiserDepositsReminderEmail>
        <PreviewFinalGuestListEmail :show="show_final_guestlist_dialog" :lead="event.lead" :event="event"
            @close="show_final_guestlist_dialog = false"></PreviewFinalGuestListEmail>
        <PreviewOrganiserPaymentSummaryEmail :show="organiser_payment_summary_dialog" :lead="event.lead"
            :event="event" :company_id="get_selected_company.id" :currency="get_selected_company.currency"
            :rows="paymentSummaryRows" @close="organiser_payment_summary_dialog = false">
        </PreviewOrganiserPaymentSummaryEmail>
    </v-container>
</template>

<script>
import { mapGetters } from "vuex"
import {
    eventPayments, personPaymentStatus, personPaymentSummary, personPaymentDates, personPackageName,
    personTotalPaid, personAdminFee, paymentSummaryRows, stagHenInviteeId,
} from "@/utils/eventPayments"
import PreviewFinalGuestListEmail from "./components/PreviewFinalGuestListEmail.vue"
import PreviewOrganiserEmail from "./components/PreviewOrganiserEmail.vue"
import PreviewOrganiserItineraryEmail from "./components/PreviewOrganiserItineraryEmail.vue"
import PreviewOrganiserBalanceDueEmail from "./components/PreviewOrganiserBalanceDueEmail.vue"
import PreviewOrganiserDepositsReminderEmail from "./components/PreviewOrganiserDepositsReminderEmail.vue"
import PreviewInviteeEmail from "./components/PreviewInviteeEmail.vue"
import PreviewOrganiserPaymentSummaryEmail from "./components/PreviewOrganiserPaymentSummaryEmail.vue"
import { lookups, loadLookups } from "@/common/companyLookups"
import { isBookingClosed } from "@/utils/eventStatus"
import EventStatusSelect from "./components/EventStatusSelect.vue"
import { noteOrigin } from "@/utils/noteOrigin"

export default {
    components: {
        PreviewFinalGuestListEmail,
        PreviewOrganiserPaymentSummaryEmail,
        PreviewOrganiserEmail,
        PreviewOrganiserItineraryEmail,
        PreviewOrganiserBalanceDueEmail,
        PreviewOrganiserDepositsReminderEmail,
        PreviewInviteeEmail,
        EventStatusSelect,
    },
    data: () => ({
        show_final_guestlist_dialog: false,
        organiser_itinerary_dialog: false,
        organiser_balance_due_dialog: false,
        organiser_deposits_reminder_dialog: false,
        organiser_payment_summary_dialog: false,
        app_url: null,
        page_name: "Invitees",
        headers: [
            // { text: '', width: '5%', sortable: false, value: 'checkbox' },
            { text: 'Name', sortable: false, value: 'name' },
            { text: 'Email & Mobile Number', sortable: false, value: 'email' },
            { text: 'Total Amount Paid', sortable: false },
            { text: 'Date of Payment', sortable: false },
            // { text: 'Deposit Paid Date', sortable: false },
            // { text: 'Package Paid', sortable: false },
            // { text: 'Package Paid Date', sortable: false },
            // { text: 'Contribution', sortable: false },
            // { text: 'Payment Type', sortable: false },
            { text: 'Payment Status', sortable: false },
            // { text: 'Invitee Dep Paid', sortable: false },
            { text: 'Quote Paid', sortable: false },
            // { text: 'Role Paid', sortable: false },
            { text: 'Action', width: '12%', sortable: false },
        ],
        payment_types: [],
        menu: false,
        payments_to_add: {
            amount: null,
            payment_type_id: null,
            payment_date: null,
            paid_to: null,
            quote_id: null,
        },
        payments_towards_user: [],
        payments_towards_others: [],
        view_payments_dialog: false,
        view_payment_owner_type: null,
        view_payments_target: null,
        search: null,
        classes: {
        },
        events: [],
        checked_invitees: [],
        checked_all_invitees: false,
        notes_dialog: false,
        new_note_content: null,
        add_invitee_dialog: false,
        new_invitee: {
            name: null,
            email: null,
            mobile: null,
        },
        add_guests_dialog: false,
        guestlist: {
            number: 0,
            quote: null,
        },
        delete_invitee_dialog: false,
        invitee_to_delete: null,
        delete_invitees_dialog: false,
        invitees_to_delete: [],
        selected_invitee: null,
        mark_invitee_as_paid_dialog: false,
        mark_paid_dialog: false,
        invitee_to_mark_paid: null,
        mark_unpaid_dialog: false,
        // Organiser ⋮ → Mark as Paid in Full (No Payment) / Mark as Unpaid
        organiser_paid_confirm: { show: false, undo: false, loading: false },
        invitee_to_mark_unpaid: null,
        payment_to_remove: null,
        mark_invitees_as_paid_dialog: false,
        selected_quote: null,
        selected_payment_type: null,
        selected_payment_gateway: null,
        update_invitee_dialog: false,
        invitee_to_update: {
            id: null,
            name: null,
            email: null,
            mobile: null,
        },
        confirmation: null,
        organiser_email_dialog: false,
        confirmationSendInvEmail: false,
        invitee_to_email: null,
        pay_organiser_dialog: false,
        organiser_paid_type: null,
        custom_amount: 0,
        reference_code: null,
        organiser_deposit_link_dialog: false,
        selected_deposit_quote: null,
        assign_contributions_dialog: false,
        // Shared "are you sure?" dialog for the payment-line delete buttons
        delete_confirm: { show: false, title: '', message: '', run: null, loading: false },
        // Assign Contributions → swap: turn a contribution into the payer's own Deposit / Full Payment
        convert_contribution: { show: false, item: null, payment_type_id: 2, quote_id: null, loading: false },
        show_price_mismatches: false,
        contribution_headers: [
            { text: 'Paid By', sortable: false, value: 'paid_by_name' },
            { text: 'Date', sortable: false, value: 'payment_date' },
            { text: 'Amount', sortable: false, value: 'amount' },
            { text: 'Assigned To', sortable: false, value: 'paid_to', width: '280px' },
        ],
        view_bulk_payments_dialog: false,
        bulk_payment_headers: [
            { text: 'Paid By', sortable: false, value: 'paid_by_name' },
            { text: 'Date', sortable: false, value: 'payment_date' },
            { text: 'Amount', sortable: false, value: 'amount' },
            { text: 'Notes', sortable: false, value: 'notes' },
        ],
        new_contributor_user_id: null,
    }),
    created() {
    },
    mounted() {
        this.getPaymentTypes()
        this.app_url = process.env.VUE_APP_CLIENT_URL
        loadLookups('advisors')
    },
    computed: {
        getAdvisors() {
            return lookups.advisors
        },
        ...mapGetters({
            get_user: 'auth/get_user',
            get_selected_company: 'auth/get_selected_company',
            event: 'eventsStore/getSelectedEventGetter',
        }),
        // Booking Closed: invitee/organiser changes and payments are locked (BOOKING_CLOSED_LOCK.md)
        locked() {
            return isBookingClosed(this.event)
        },
        contributorUserIds() {
            return (this.event.contributors || []).map(c => c.user_id)
        },
        sortedContributors() {
            return [...(this.event.contributors || [])].sort((a, b) => (a.user?.role?.id ?? Infinity) - (b.user?.role?.id ?? Infinity))
        },
        companyContributorUsers() {
            return (this.getAdvisors || []).filter(u => u.role?.id !== 1 && (u.access || []).some(a => a.company_id === this.get_selected_company.id))
        },
        availableContributorUsers() {
            return this.companyContributorUsers
                .filter(u => !this.contributorUserIds.includes(u.id))
                .sort((a, b) => (a.role?.id ?? Infinity) - (b.role?.id ?? Infinity))
        },
        // Every completed payment on the event, searched by paid_to (see utils/eventPayments.js).
        eventPayments() {
            return eventPayments(this.event)
        },
        paidToDate() {
            // Admin fee only applies to invitees who've paid in full, never the organizer.
            const admin_fee_total = this.event.invitees.reduce((sum, inv) => sum + personAdminFee(this.event, inv.id), 0)
            const quote_total = this.eventPayments.reduce((total, p) => {
                const validDetails = p.payment_details.filter(d => [1, 2].includes(d.payment_type_id) && !d.is_charge)
                return total + validDetails.reduce((sum, d) => sum + d.amount, 0)
            }, 0)
            return quote_total + admin_fee_total
        },
        // Every payment_details row for this event (lead + invitees) — used for the
        // Fees breakdown, which reports charges (processing/admin fees) that are
        // deliberately excluded from Paid to Date and Total Amount Paid.
        allPaymentDetails() {
            return this.eventPayments.flatMap(p => p.payment_details)
        },
        // Matches the sum of the "Total Amount Paid" column in the invitees table
        // below: everything credited to an organiser/invitee (Paid to Date,
        // Contributions, Bulk Payments) but not processing/admin fee charges — those
        // are shown separately in Fees so they're visible without inflating this total.
        totalAmountPaid() {
            return this.paidToDate + this.totalContributions + this.totalBulkPayments
        },
        // Organiser payment summary email rows — same figures as the invitees table.
        // Shared with the events list's Email Organiser → Payment Summary (utils/eventPayments.js)
        paymentSummaryRows() {
            return paymentSummaryRows(this.event)
        },
        totalFees() {
            return this.allPaymentDetails
                .filter(d => d.is_charge)
                .reduce((sum, d) => sum + Number(d.amount), 0)
        },
        sign_up_link() {
            return process.env.VUE_APP_CLIENT_URL + this.get_selected_company.company_name + '/signup/' + this.event.id
        },
        login_link() {
            return process.env.VUE_APP_CLIENT_URL + this.get_selected_company.company_name.toLowerCase()
        },
        organiserDepositLink() {
            if (!this.selected_deposit_quote) return ''
            return process.env.VUE_APP_CLIENT_URL + this.get_selected_company.company_name + '/organiser_deposit/' + this.selected_deposit_quote.id
        },
        allContributions() {
            const list = []
            this.eventPayments.forEach(payment => {
                payment.payment_details
                    .filter(d => d.payment_type_id == 6)
                    .forEach(detail => {
                        list.push({
                            id: detail.id,
                            paid_by: payment.paid_by,
                            paid_by_name: this.getPersonLabel(payment.paid_by),
                            payment_date: payment.payment_date,
                            amount: detail.amount,
                            paid_to: detail.paid_to,
                            owner_type: payment.paid_by_role === 'lead' ? 'lead' : 'invitee',
                        })
                    })
            })
            return list
        },
        // Organiser and invitees whose payments don't match their package's current price
        // (banner above the invitees table; each row also carries the flag)
        priceMismatches() {
            if (!this.event?.lead) return []
            const lead = this.event.lead
            return [
                { name: `${lead.first_name} ${lead.last_name ?? ''}`.trim(), summary: personPaymentSummary(this.event, lead.id) },
                ...(this.event.invitees || []).map(inv => ({ name: inv.name, summary: personPaymentSummary(this.event, inv.id) })),
            ].filter(row => row.summary.mismatch)
        },
        priceMismatchLabel() {
            const count = this.priceMismatches.length
            return 'Show price mismatches' + (count ? ` (${count} mismatch${count === 1 ? '' : 'es'})` : '')
        },
        contributionHeaders() {
            return [...this.contribution_headers, { text: '', sortable: false, value: 'actions', width: '80px' }]
        },
        totalContributions() {
            return this.allContributions.reduce((total, c) => total + Number(c.amount), 0)
        },
        allBulkPayments() {
            const list = []
            this.eventPayments.forEach(payment => {
                payment.payment_details
                    .filter(d => d.payment_type && d.payment_type.type === 'Bulk')
                    .forEach(detail => {
                        list.push({
                            id: detail.id,
                            paid_by_name: this.getPersonLabel(payment.paid_by),
                            payment_date: payment.payment_date,
                            amount: detail.amount,
                            notes: detail.notes,
                        })
                    })
            })
            return list
        },
        totalBulkPayments() {
            return this.allBulkPayments.reduce((total, b) => total + Number(b.amount), 0)
        },
        assignablePersons() {
            return [
                { id: this.event.lead.id, label: this.event.lead.first_name + ' ' + this.event.lead.last_name + ' (Organizer)' },
                ...this.event.invitees.map(inv => ({ id: inv.id, label: inv.name }))
            ]
        },
        // See utils/eventPayments.js; same rule in ggb_client_app's invitee lists
        stagHenInviteeId() {
            return stagHenInviteeId(this.event)
        },
    },
    methods: {
        noteOrigin,
        filterContributorOptions(item, queryText) {
            const query = queryText.toLowerCase()
            const name = (item.name || '').toLowerCase()
            const role = (item.role?.name || '').toLowerCase()
            return name.includes(query) || role.includes(query)
        },
        contributorOptions(contributor) {
            return (this.getAdvisors || [])
                .filter(u => {
                    if (u.id === contributor.user_id) return true
                    if (u.role?.id === 1) return false
                    const hasCompanyAccess = (u.access || []).some(a => a.company_id === this.get_selected_company.id)
                    return hasCompanyAccess && !this.contributorUserIds.includes(u.id)
                })
                .sort((a, b) => (a.role?.id ?? Infinity) - (b.role?.id ?? Infinity))
        },
        async addEventContributor(user_id) {
            if (!user_id) return
            const result = await (await this.$axios.post('admin/events/create_event_contributor', {
                event_id: this.event.id,
                user_id,
            })).data
            if (result.response == true) {
                this.$toast.success('Contributor added')
                this.new_contributor_user_id = null
                this.$emit('refresh')
            } else {
                this.$toast.error('Failed to add contributor')
            }
        },
        async replaceEventContributor(contributor, user_id) {
            if (!user_id || user_id == contributor.user_id) return
            const result = await (await this.$axios.post(`admin/events/update_event_contributor/${contributor.id}`, { user_id })).data
            if (result.response == true) {
                this.$toast.success('Contributor updated')
                this.$emit('refresh')
            } else {
                this.$toast.error('Failed to update contributor')
            }
        },
        async deleteEventContributor(contributor) {
            const result = await (await this.$axios.delete(`admin/events/delete_event_contributor/${contributor.id}`)).data
            if (result.response == true) {
                this.$toast.success('Contributor removed')
                this.$emit('refresh')
            } else {
                this.$toast.error('Failed to remove contributor')
            }
        },
        async getPaymentTypes() {
            await this.$axios.get('admin/payments/get_payment_types')
                .then(({ data }) => {
                    if (data.response) {
                        this.payment_types = data.data
                    }
                })
        },
        getPersonLabel(id) {
            const match = this.assignablePersons.find(p => p.id == id)
            return match ? match.label : '-'
        },
        openViewPaymentsDialog(item, ownerType) {
            this.view_payment_owner_type = ownerType
            this.view_payments_target = item

            const allPayments = this.eventPayments

            const towardsUserCards = []
            const towardsOthersCards = []

            allPayments.forEach(payment => {
                const paidByLabel = this.getPersonLabel(payment.paid_by)
                const isOwnPayment = payment.paid_by == item.id

                const userRows = []
                const othersByTarget = {}

                payment.payment_details.forEach(detail => {
                    const isAdminFee = detail.is_charge && detail.payment_type_id == 8
                    const isLateFee = detail.is_charge && detail.payment_type && detail.payment_type.type === 'Late Fee'
                    const isQuotePayment = !detail.is_charge && (detail.payment_type_id == 1 || detail.payment_type_id == 2)
                    const isContribution = !detail.is_charge && detail.payment_type_id == 6
                    // Only quote payments (Full Payment/Deposit), contributions assigned to someone,
                    // the Admin Fee and the Late Fee are shown here — other charges (gateway
                    // processing fees, etc.) are left out.
                    if (!isAdminFee && !isLateFee && !isQuotePayment && !isContribution) return

                    const row = {
                        detail,
                        label: isAdminFee ? 'Admin Fee' : (detail.payment_type ? detail.payment_type.type : '-'),
                        quote: detail.quote ? detail.quote.name : null,
                        amount: detail.amount,
                        deletable: isOwnPayment,
                    }

                    if (detail.paid_to == item.id) {
                        userRows.push(row)
                    } else if (isOwnPayment) {
                        const targetId = detail.paid_to
                        if (!othersByTarget[targetId]) othersByTarget[targetId] = []
                        othersByTarget[targetId].push(row)
                    }
                })

                if (userRows.length) {
                    towardsUserCards.push({
                        payment,
                        paidBy: isOwnPayment ? 'Self' : paidByLabel,
                        rows: userRows,
                    })
                }

                Object.keys(othersByTarget).forEach(targetId => {
                    towardsOthersCards.push({
                        payment,
                        paidTowards: targetId === 'null' ? 'Unassigned' : this.getPersonLabel(targetId),
                        rows: othersByTarget[targetId],
                    })
                })
            })

            const byPaymentDate = (a, b) => new Date(a.payment.payment_date) - new Date(b.payment.payment_date)
            towardsUserCards.sort(byPaymentDate)
            towardsOthersCards.sort(byPaymentDate)

            this.payments_towards_user = towardsUserCards
            this.payments_towards_others = towardsOthersCards
            this.view_payments_dialog = true
        },
        closeViewPaymentsDialog() {
            this.payments_towards_user = []
            this.payments_towards_others = []
            this.view_payment_owner_type = null
            this.view_payments_target = null
            this.view_payments_dialog = false
        },
        getCardTotal(card) {
            return card.rows.reduce((sum, row) => sum + Number(row.amount), 0)
        },
        openDeleteConfirm(title, message, run) {
            this.delete_confirm = { show: true, title, message, run, loading: false }
        },
        closeDeleteConfirm() {
            this.delete_confirm = { show: false, title: '', message: '', run: null, loading: false }
        },
        async runDeleteConfirm() {
            this.delete_confirm.loading = true
            try {
                await this.delete_confirm.run()
            } finally {
                this.closeDeleteConfirm()
            }
        },
        askDeleteViewedPaymentDetail(card, row, section) {
            const paidTo = row.detail.paid_to == null ? 'Unassigned' : this.getPersonLabel(row.detail.paid_to)
            const amount = `${this.get_selected_company.currency}${Number(row.amount).toFixed(2)}`
            const date = this.$date(card.payment.payment_date).format('DD/MM/YYYY')
            this.openDeleteConfirm(
                'Delete payment line?',
                `Delete ${row.label} ${amount} for ${paidTo} (paid ${date})?`,
                () => this.deleteViewedPaymentDetail(card, row, section)
            )
        },
        askDeleteContribution(item) {
            const amount = `${this.get_selected_company.currency}${Number(item.amount).toFixed(2)}`
            this.openDeleteConfirm(
                'Delete contribution?',
                `Delete the ${amount} contribution paid by ${item.paid_by_name} on ${item.payment_date}?`,
                () => this.deleteContribution(item)
            )
        },
        async deleteViewedPaymentDetail(card, row, section) {
            const { payment } = card
            const { detail } = row
            let result
            if (this.view_payment_owner_type === 'lead') {
                result = await (await this.$axios.delete(`admin/leads/delete_lead_payment_detail/${detail.id}`)).data
            } else {
                result = await (await this.$axios.delete(`admin/invitees/delete_invitee_payment_detail/${detail.id}`)).data
            }
            if (result && result.response == true) {
                this.$toast.success('Payment detail deleted')
                payment.total_paid_amount = Number(payment.total_paid_amount) - Number(detail.amount)
                const detailIndex = payment.payment_details.indexOf(detail)
                if (detailIndex > -1) {
                    payment.payment_details.splice(detailIndex, 1)
                }
                const rowIndex = card.rows.indexOf(row)
                if (rowIndex > -1) {
                    card.rows.splice(rowIndex, 1)
                }
                if (card.rows.length === 0) {
                    const list = section === 'towards_user' ? this.payments_towards_user : this.payments_towards_others
                    const cardIndex = list.indexOf(card)
                    if (cardIndex > -1) list.splice(cardIndex, 1)
                }
                this.$emit('refresh')
            } else {
                this.$toast.error('Failed to delete payment detail')
            }
        },
        getOrganizerTotal() {
            return personTotalPaid(this.event, this.event.lead.id)
        },
        // Shared with the Booked Events Paid column (see utils/eventPayments.js).
        getOrganizerStatus() {
            return personPaymentStatus(this.event, this.event.lead.id)
        },
        getOrganizerSummary() {
            return personPaymentSummary(this.event, this.event.lead.id)
        },
        getInviteeSummary(item) {
            return personPaymentSummary(this.event, item.id)
        },
        mismatchLabel(summary) {
            const amount = `${this.get_selected_company.currency}${Math.abs(summary.difference).toFixed(2)}`
            return summary.difference < 0 ? `${amount} short` : `${amount} over`
        },
        mismatchTooltip(summary) {
            const currency = this.get_selected_company.currency
            return `Paid ${currency}${summary.paid.toFixed(2)}; the package is now ${currency}${summary.price.toFixed(2)} per person`
        },
        getOrganizerPackage() {
            return personPackageName(this.event, this.event.lead.id)
        },
        // Includes the admin fee once they've paid in full (see personTotalPaid)
        getInviteeTotal(item) {
            return personTotalPaid(this.event, item.id)
        },
        // Matched by paid_to (who the money was assigned to), whoever paid it — the
        // invitee, the organiser or another invitee. See utils/eventPayments.js.
        getInviteeStatus(item) {
            return personPaymentStatus(this.event, item.id)
        },
        getInviteePackage(item) {
            return personPackageName(this.event, item.id)
        },
        getGuestCountForQuote(quote) {
            let count = 0

            // Check if lead has paid in full for this quote
            const leadPackage = this.getOrganizerPackage()
            if (leadPackage === quote.name) {
                count++
            }

            // Check each invitee
            this.event.invitees.forEach(invitee => {
                const inviteePackage = this.getInviteePackage(invitee)
                if (inviteePackage === quote.name) {
                    count++
                }
            })

            return count
        },
        openAssignContributionsDialog() {
            this.assign_contributions_dialog = true
        },
        closeAssignContributionsDialog() {
            this.assign_contributions_dialog = false
        },
        openViewBulkPaymentsDialog() {
            this.view_bulk_payments_dialog = true
        },
        closeViewBulkPaymentsDialog() {
            this.view_bulk_payments_dialog = false
        },
        async assignContribution(detail_id, paid_to) {
            const result = await (await this.$axios.patch(`admin/invitees/assign_contribution/${detail_id}`, { paid_to: paid_to ?? null })).data
            if (result.response == true) {
                this.$toast.success('Contribution assigned successfully')
                this.$emit('refresh')
            } else {
                this.$toast.error('Failed to assign contribution')
            }
        },
        async deleteContribution(item) {
            const endpoint = item.owner_type === 'lead'
                ? `admin/leads/delete_lead_payment_detail/${item.id}`
                : `admin/invitees/delete_invitee_payment_detail/${item.id}`
            const result = await (await this.$axios.delete(endpoint)).data
            if (result && result.response == true) {
                this.$toast.success('Contribution deleted')
                this.$emit('refresh')
            } else {
                this.$toast.error('Failed to delete contribution')
            }
        },
        openConvertContribution(item) {
            const quotes = this.event.quotes || []
            const payer = item.owner_type === 'invitee' ? this.event.invitees.find(inv => inv.id == item.paid_by) : null
            const payerQuote = quotes.find(q => q.id == payer?.quote_id)
            this.convert_contribution = {
                show: true,
                item,
                payment_type_id: 2,
                quote_id: payerQuote?.id ?? (quotes.length === 1 ? quotes[0].id : null),
                loading: false,
            }
        },
        closeConvertContribution() {
            this.convert_contribution = { show: false, item: null, payment_type_id: 2, quote_id: null, loading: false }
        },
        async convertContribution() {
            const { item, payment_type_id, quote_id } = this.convert_contribution
            this.convert_contribution.loading = true
            try {
                const result = await (await this.$axios.patch(`admin/invitees/convert_contribution/${item.id}`, {
                    payment_type_id,
                    quote_id: payment_type_id === 1 ? quote_id : null,
                })).data
                if (result.response == true) {
                    this.$toast.success(result.message)
                    this.closeConvertContribution()
                    this.$emit('refresh')
                } else {
                    this.$toast.error(result.message || 'Failed to change contribution')
                }
            } catch (e) {
                this.$toast.error(e.response?.data?.message || 'Failed to change contribution')
            } finally {
                this.convert_contribution.loading = false
            }
        },
        // EventStatusSelect has already asked for CONFIRM if this unlocks a Booking Closed event
        async updateEventStatus(status) {
            const previous = this.event.event_status
            this.event.event_status = status
            try {
                const result = await (await this.$axios.post(`admin/events/update_event/${this.event.id}`, {
                    event_status: status,
                    company_id: this.get_selected_company.id,
                })).data
                if (result.response == true) {
                    this.$toast.success('Event status updated successfully')
                    await this.addStatusChangeNote(status)
                    this.$emit('refresh')
                } else {
                    this.event.event_status = previous
                    this.$toast.error('Failed to update event status')
                }
            } catch (error) {
                this.event.event_status = previous
                this.$toast.error('Failed to update event status')
                console.error(error)
            }
        },
        // The status itself is already saved, so a failed note only warns rather than reverting it
        async addStatusChangeNote(status) {
            try {
                const result = (await this.$axios.post('admin/events/create_event_note', {
                    event_id: this.event.id,
                    note_content: `Changed status to ${status}`,
                })).data
                if (result.response != true) {
                    this.$toast.error('Status updated but failed to add note')
                }
            } catch (error) {
                this.$toast.error('Status updated but failed to add note')
                console.error(error)
            }
        },
        openPayOrganiserDialog() {
            this.pay_organiser_dialog = true
        },
        closePayOrganiserDialog() {
            this.pay_organiser_dialog = false
            this.selected_quote = null
            this.selected_payment_type = null
            this.selected_payment_gateway = null
            this.organiser_paid_type = null
            this.custom_amount = 0
            this.reference_code = null
        },
        async markOrganiserAsPaid() {
            if (this.selected_quote == null || this.reference_code == null || this.custom_amount == 0 || this.selected_payment_type == null || this.selected_payment_gateway == null) {
                this.$toast.error('Please fill out all fields')
                return
            }

            let payload = {
                event_id: this.event.id,
                company_id: this.get_selected_company.id,
                total_paid_amount: this.custom_amount,
                payment_date: this.$date().format('YYYY-MM-DD hh:mm:ss'),
                reference_code: this.reference_code,
                event_name: this.event.name,
                quote_id: this.selected_quote.id ?? 0,
                paid_by: this.event.lead.id,
                payment_type_id: this.selected_payment_type.id,
                payment_gateway: this.selected_payment_gateway,
            }
            console.log(payload)
            const result = await (await this.$axios.post(`admin/leads/mark_lead_as_paid/${payload.paid_by}`, payload)).data
            if (result.response == true) {
                this.$toast.success(result.message)
                this.closePayOrganiserDialog()
                this.$emit('refresh')
            }
            else {
                this.$toast.error(result.data.message)
            }
        },
        addPayment() {
            this.payments_to_add.push({
                amount: null,
                payment_type_id: null,
                payment_date: null,
                paid_to: null,
                quote_id: null,
            })
        },
        openMarkInviteeAsPaidDialog(item) {
            this.mark_invitee_as_paid_dialog = true
            this.selected_invitee = item
            console.log(item)
        },
        closeMarkInviteeAsPaidDialog() {
            this.mark_invitee_as_paid_dialog = false
            this.selected_invitee = null
            this.selected_quote = null
            this.reference_code == null
            this.payments_to_add = {
                amount: null,
                payment_type_id: null,
                payment_date: null,
                paid_to: null,
                quote_id: null,
            }
        },
        async markInviteeAsPaid() {
            if (this.selected_quote == null || this.reference_code == null) {
                this.$toast.error('Please fill out all fields')
                return
            }
            let payload = {
                event_id: this.event.id,
                company_id: this.get_selected_company.id,
                total_paid_amount: this.custom_amount,
                payment_date: this.$date().format('YYYY-MM-DD hh:mm:ss'),
                reference_code: this.reference_code,
                event_name: this.event.name,
                quote_id: this.selected_quote.id ?? 0,
                paid_by: this.selected_invitee.id,
                payment_type_id: this.selected_payment_type.id,
                payment_gateway: this.selected_payment_gateway,
            }
            console.log(payload)
            const result = await (await this.$axios.post(`admin/invitees/mark_invitee_as_paid/${payload.paid_by}`, payload)).data
            if (result.response == true) {
                this.$toast.success(result.message)
                this.closeMarkInviteeAsPaidDialog()
                this.$emit('refresh')
            }
        },
        openMarkPaidDialog(item) {
            this.invitee_to_mark_paid = item
            this.mark_paid_dialog = true
        },
        closeMarkPaidDialog() {
            this.mark_paid_dialog = false
            this.invitee_to_mark_paid = null
        },
        async confirmMarkPaid() {
            const invitee = this.invitee_to_mark_paid
            const payload = {
                event_id: this.event.id,
                company_id: this.get_selected_company.id,
                total_paid_amount: 0,
                payment_date: this.$date().format('YYYY-MM-DD hh:mm:ss'),
                reference_code: `Marked paid (no payment) - ${Date.now()}`,
                event_name: this.event.name,
                quote_id: 0,
                paid_by: invitee.id,
                payment_type_id: 1,
                payment_gateway: 'Manual',
            }
            const result = await (await this.$axios.post(`admin/invitees/mark_invitee_as_paid/${invitee.id}`, payload)).data
            if (result.response == true) {
                this.$toast.success(`${invitee.name} marked as paid`)
                this.closeMarkPaidDialog()
                this.$emit('refresh')
            } else {
                this.$toast.error('Failed to mark invitee as paid')
            }
        },
        // Delete Invitee is only safe once there's no real payment to lose. Some
        // invitees end up with empty payment shells and nothing to show for them —
        // an abandoned online payment attempt (gateway record created, never
        // completed) or a "Mark as Paid"/"Mark as Unpaid" pair that removed the
        // payment_details but left the zero-amount Payment row behind — so checking
        // item.payments.length alone wrongly blocks deletion for those.
        hasRealPayments(item) {
            return (item.payments || []).some(p => (p.payment_details || []).length > 0)
        },
        // Finds the zero-amount Full Payment record created by the "Mark as Paid (No
        // Payment)" action above, identified by its 'Manual' payment_gateway — the only
        // real payment flows use Stripe/Sagepay/Authipay, so this can't collide with an
        // actual payment.
        getManualMarkPaidPayment(item) {
            return (item.payments || []).find(p =>
                p.payment_gateway === 'Manual' &&
                (p.payment_details || []).some(d => d.payment_type_id == 1 && d.paid_to == item.id && !d.is_charge)
            ) || null
        },
        // Staff's "Mark as Paid in Full (No Payment)" on the organiser: a £0 Manual Full Payment, which
        // the status rules treat as Paid in Full and never a mismatch (same as for invitees)
        getOrganizerManualMarkPaidPayment() {
            const leadId = this.event.lead.id
            return (this.event.lead.payments || []).find(p =>
                p.payment_gateway === 'Manual' &&
                (p.payment_details || []).some(d => d.payment_type_id == 1 && d.paid_to == leadId && !d.is_charge && Number(d.amount) === 0)
            ) || null
        },
        async confirmOrganiserMarkPaid() {
            const lead = this.event.lead
            const quotes = this.event.quotes || []
            const fullPayment = this.eventPayments
                .flatMap(p => p.payment_details || [])
                .find(d => d.paid_to == lead.id && d.payment_type_id == 1 && Number(d.quote_id) > 0)
            // Keep the organiser on their package: markLeadAsPaid also saves this as leads.quote_id
            const quoteId = (Number(lead.quote_id) > 0 && lead.quote_id) || fullPayment?.quote_id || (quotes.length === 1 ? quotes[0].id : 0)
            this.organiser_paid_confirm.loading = true
            try {
                const result = (await this.$axios.post(`admin/leads/mark_lead_as_paid/${lead.id}`, {
                    event_id: this.event.id,
                    company_id: this.get_selected_company.id,
                    total_paid_amount: 0,
                    payment_date: this.$date().format('YYYY-MM-DD HH:mm:ss'),
                    reference_code: `Marked paid (no payment) - ${Date.now()}`,
                    event_name: this.event.name,
                    quote_id: quoteId,
                    paid_by: lead.id,
                    payment_type_id: 1,
                    payment_gateway: 'Manual',
                })).data
                if (result.response == true) {
                    this.$toast.success('Organiser marked as Paid in Full')
                    this.organiser_paid_confirm = { show: false, undo: false, loading: false }
                    this.$emit('refresh')
                } else {
                    this.$toast.error('Failed to mark the organiser as paid')
                }
            } finally {
                this.organiser_paid_confirm.loading = false
            }
        },
        async confirmOrganiserMarkUnpaid() {
            const payment = this.getOrganizerManualMarkPaidPayment()
            if (!payment) return
            this.organiser_paid_confirm.loading = true
            try {
                const result = (await this.$axios.delete(`admin/leads/delete_lead_payment/${payment.id}`)).data
                if (result.response == true) {
                    this.$toast.success('Organiser marked as unpaid')
                    this.organiser_paid_confirm = { show: false, undo: false, loading: false }
                    this.$emit('refresh')
                } else {
                    this.$toast.error('Failed to mark the organiser as unpaid')
                }
            } finally {
                this.organiser_paid_confirm.loading = false
            }
        },
        openMarkUnpaidDialog(item) {
            this.invitee_to_mark_unpaid = item
            this.payment_to_remove = this.getManualMarkPaidPayment(item)
            this.mark_unpaid_dialog = true
        },
        closeMarkUnpaidDialog() {
            this.mark_unpaid_dialog = false
            this.invitee_to_mark_unpaid = null
            this.payment_to_remove = null
        },
        // RSVP shown for an invitee: 'declined' until they pay in full (the API's Invitee::isDeclined());
        // otherwise paying the deposit or in full counts as coming without a click, as in my-stagit.
        // Unpaid with no answer shows nothing.
        rsvpOf(item) {
            if (item.rsvp_status === 'declined' && !item.paid) return 'declined'
            if (item.rsvp_status === 'attending' || item.paid || item.deposit_paid) return 'attending'
            return null
        },
        // Staff change, no emails (the invitee's own answer in the portal emails them and the organiser)
        async setRsvp(item, status) {
            try {
                const result = (await this.$axios.post(`admin/invitees/set_rsvp/${item.id}`, { status })).data
                if (result.response == true) {
                    this.$set(item, 'rsvp_status', result.data.rsvp_status)
                    this.$set(item, 'rsvp_at', result.data.rsvp_at)
                    this.$toast.success(status === 'declined' ? `${item.name} marked as not coming`
                        : status === 'attending' ? `${item.name} marked as coming` : `RSVP cleared for ${item.name}`)
                } else {
                    this.$toast.error(result.message || 'Failed to update RSVP')
                }
            } catch (e) {
                this.$toast.error(e.response?.data?.message || 'Failed to update RSVP')
            }
        },
        async setStagHen(item) {
            try {
                const result = (await this.$axios.post(`admin/invitees/set_stag_hen/${item.id}`)).data
                if (result.response == true) {
                    this.$set(this.event, 'stag_hen_invitee_id', result.data.stag_hen_invitee_id)
                    this.$toast.success(`${item.name} set as Stag/Hen`)
                } else {
                    this.$toast.error(result.message || 'Failed to set Stag/Hen')
                }
            } catch (e) {
                this.$toast.error(e.response?.data?.message || 'Failed to set Stag/Hen')
            }
        },
        async confirmMarkUnpaid() {
            if (!this.payment_to_remove) return
            const invitee = this.invitee_to_mark_unpaid
            const result = await (await this.$axios.delete(`admin/invitees/delete_invitee_payment/${this.payment_to_remove.id}`)).data
            if (result.response == true) {
                this.$toast.success(`${invitee.name} marked as unpaid`)
                this.closeMarkUnpaidDialog()
                this.$emit('refresh')
            } else {
                this.$toast.error('Failed to mark invitee as unpaid')
            }
        },
        openMarkInviteesAsPaidDialog() {
            this.mark_invitees_as_paid_dialog = true
        },
        closeMarkInviteesAsPaidDialog() {
            this.mark_invitees_as_paid_dialog = false
            this.selected_quote = null
            this.reference_code == null
        },
        async markInviteesAsPaid() {
            if (this.selected_quote == null || this.reference_code == null) {
                this.$toast.error('Please fill out all fields')
                return
            }
            let payload = {
                company_id: this.get_selected_company.id,
                event_id: this.event.id,
                invitees: this.checked_invitees,
                quote_id: this.selected_quote.id
            }
            const result = await (await this.$axios.post('admin/invitees/mark_invitees_as_paid', payload)).data
            if (result.response == true) {
                this.$toast.success(result.message)
                this.closeMarkInviteesAsPaidDialog()
                this.$emit('refresh')
            }
        },
        checkAllInvitees() {
            this.checked_all_invitees = !this.checked_all_invitees
            if (this.checked_all_invitees) {
                this.event.invitees.forEach(invitee => {
                    let index = this.checked_invitees.findIndex((items) => items.id == invitee.id)
                    if (index === -1 && !invitee.paid) {
                        this.checked_invitees.push(invitee)
                    }
                })
            }
            else {
                this.checked_invitees = []
            }
        },
        checkInvitee(item) {
            let index = this.checked_invitees.findIndex((items) => items.id == item.id)
            if (index === -1) {
                this.checked_invitees.push(item)
            }
            else {
                this.checked_invitees.splice(index, 1)
            }
        },
        openNotesDialog() {
            this.notes_dialog = true
        },
        closeNotesDialog() {
            this.notes_dialog = false
            this.new_note_content = null
        },
        async createEventNote() {
            if (!this.new_note_content) return
            const result = await (await this.$axios.post('admin/events/create_event_note', {
                event_id: this.event.id,
                note_content: this.new_note_content,
            })).data
            if (result.response == true) {
                this.$toast.success('Note added')
                this.new_note_content = null
                this.$emit('refresh')
            } else {
                this.$toast.error('Failed to add note')
            }
        },
        async deleteEventNote(note) {
            const result = await (await this.$axios.delete(`admin/events/delete_event_note/${note.id}`)).data
            if (result.response == true) {
                this.$toast.success('Note deleted')
                this.$emit('refresh')
            } else {
                this.$toast.error('Failed to delete note')
            }
        },
        openUpdateInviteeDialog(item) {
            this.update_invitee_dialog = true
            this.invitee_to_update.id = item.id
            this.invitee_to_update.name = item.name
            this.invitee_to_update.email = item.email
            this.invitee_to_update.mobile = item.mobile
        },
        closeUpdateInviteeDialog() {
            this.update_invitee_dialog = false
            this.invitee_to_update = {
                id: null,
                name: null,
                email: null,
                mobile: null,
            }
        },
        async updateInvitee() {
            let payload = {
                company_id: this.get_selected_company.id,
                event_id: this.event.id,
                ...this.invitee_to_update
            }
            const result = await (await this.$axios.post(`admin/invitees/update_invitee/${payload.id}`, payload)).data
            if (result.response == true) {
                this.$toast.success(result.message)
                this.closeUpdateInviteeDialog()
                this.$emit('refresh')
            }
            else {
                this.$toast.error(result.message || 'Failed to update invitee')
            }
        },
        openDeleteInviteeDialog(item) {
            this.delete_invitee_dialog = true
            this.invitee_to_delete = item
        },
        closeDeleteInviteeDialog() {
            this.delete_invitee_dialog = false
            this.invitee_to_delete = null
            this.confirmation = null
        },
        async deleteInvitee() {
            let payload = {
                invitee_id: this.invitee_to_delete.id,
                company_id: this.get_selected_company.id,
                event_id: this.event.id,
            }
            const result = await (await this.$axios.delete(`admin/invitees/delete_invitee/${payload.invitee_id}/${payload.company_id}/${payload.event_id}`)).data
            if (result.response == true) {
                this.$toast.success(result.message)
                this.closeDeleteInviteeDialog()
                this.$emit('refresh')
            }
        },
        openDeleteInviteesDialog() {
            this.delete_invitees_dialog = true
            this.invitees_to_delete = this.checked_invitees
        },
        closeDeleteInviteesDialog() {
            this.delete_invitees_dialog = false
            this.invitees_to_delete = []
            this.confirmation = null
        },
        async deleteInvitees() {
            let payload = {
                company_id: this.get_selected_company.id,
                event_id: this.event.id,
                invitees_to_delete: this.invitees_to_delete,
            }
            const result = await (await this.$axios.post('admin/invitees/delete_invitees', payload)).data
            if (result.response == true) {
                this.$toast.success(result.message)
                this.checked_all_invitees = false
                this.closeDeleteInviteesDialog()
                this.$emit('refresh')
            }
        },
        openAddInvitee() {
            this.add_invitee_dialog = true
        },
        closeAddInvitee() {
            this.add_invitee_dialog = false
            this.new_invitee = {
                name: null,
                email: null,
                mobile: null,
            }
        },
        async addInvitee() {
            let payload = {
                company_id: this.get_selected_company.id,
                event_id: this.event.id,
                name: this.new_invitee.name,
                email: this.new_invitee.email,
                mobile: parseInt(this.new_invitee.mobile),
                password: this.event.password,
            }
            const result = await (await this.$axios.post('admin/invitees/create_invitee', payload)).data
            if (result.response == true) {
                this.$toast.success(result.message)
                this.closeAddInvitee()
                this.$emit('refresh')
            }
            else {
                this.$toast.error(result.message || 'Failed to add invitee')
            }
        },
        openAddGuests() {
            this.add_guests_dialog = true
        },
        closeAddGuests() {
            this.add_guests_dialog = false
            this.guestlist = {
                number: 0,
                quote: null,
            }
        },
        async addGuests() {
            if (this.guestlist.number == 0 || this.guestlist.quote == null) {
                this.$toast.error('You must fill in the details')
                return
            }
            let payload = {
                company_id: this.get_selected_company.id,
                event_id: this.event.id,
                number: this.guestlist.number,
                quote_id: null,
                password: this.event.password,
            }
            if (this.guestlist.quote > 0) {
                payload.quote_id = parseInt(this.guestlist.quote)
            }
            const result = await (await this.$axios.post('admin/invitees/create_invitees', payload)).data
            if (result.response == true) {
                this.$toast.success(result.message)
                this.closeAddGuests()
                this.$emit('refresh')
            }
        },
        openConfirmSendInviteeEmail(item) {
            this.invitee_to_email = item
            this.confirmationSendInvEmail = true
        },
        copyLinkV2() {
            navigator.clipboard.writeText(`${process.env.VUE_APP_CLIENT_URL}${this.get_selected_company.company_name}/signup/${this.event.id}`)
            this.$toast.success('Copied link to clipboard')
        },
        copyLoginLink() {
            navigator.clipboard.writeText(this.login_link)
            this.$toast.success('Copied link to clipboard')
        },
        openOrganiserDepositLinkDialog() {
            this.organiser_deposit_link_dialog = true
        },
        closeOrganiserDepositLinkDialog() {
            this.organiser_deposit_link_dialog = false
            this.selected_deposit_quote = null
        },
        copyOrganiserDepositLink() {
            if (!this.organiserDepositLink) return
            navigator.clipboard.writeText(this.organiserDepositLink)
            this.$toast.success('Organiser deposit link copied to clipboard')
        },
        getOrganizerPaymentDates() {
            return personPaymentDates(this.event, this.event.lead.id)
        },
        getInviteePaymentDates(item) {
            return personPaymentDates(this.event, item.id)
        },
    }
}
</script>

<style lang="scss" scoped>
.card-format {
    border-radius: 15px !important;

    .v-data-footer {
        background-color: #E9E9E9;
        color: #7C7C7C;
        font-family: 'Work Sans';
    }

    .v-data-footer__select .v-text-field {
        background-color: white;

        .v-select__slot {
            padding-left: 10px;
        }
    }
}

.custom-small {
    color: #7C7C7C;
    font-size: 12px;
    font-weight: 600;
}

:deep(.theme--light.v-data-table tbody td) {
    height: 80px;
    border: none;
}

.label-text-color {
    color: #7C7C7C;
}

.text-proper-case {
    text-transform: capitalize;
}

.search-text-field {
    margin-top: 15px;

    .v-input__slot {
        min-height: 0 !important;
        margin-top: 8px;
    }

    .v-input__prepend-inner {
        margin-top: 5px !important;
    }
}

:deep(.custom-buttons span) {
    text-transform: none;
    font-family: Manrope;
    font-size: 13px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: normal;
    box-shadow: none !important;
}

:deep(.custom-buttons button) {
    padding: 8px 7px 8px 7px !important;
    border-radius: 5px;
}

.paid_row {
    background-color: #FFF1F1 !important;
}

.price-mismatch {
    font-size: 12px;
    font-weight: 600;
    color: #E65100;
    white-space: nowrap;
    cursor: default;
}

.info-card {
    border-radius: 10px !important;
    overflow: hidden;
    border: 1px solid #E9E9E9 !important;
    box-shadow: 5px 5px 13px 0px rgba(240, 240, 240, 0.90), -5px -5px 10px 0px rgba(255, 255, 255, 0.90) !important;
}

.info-card-header {
    background: linear-gradient(135deg, #3988AA 0%, #2a6a88 100%);
    font-family: Manrope;
    font-size: 13px;
    font-weight: 700;
    color: white;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.section-label {
    font-size: 11px;
    font-weight: 700;
    color: #9E9E9E;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.payment-detail-card {
    border-radius: 8px !important;
    border-color: #E9E9E9 !important;
}

.payment-detail-row {
    padding: 6px 0;
    font-size: 13px;
    border-top: 1px solid #F5F5F5;

    &:first-child {
        border-top: none;
    }
}

.info-item {
    margin-bottom: 14px;

    &.mb-0 {
        margin-bottom: 0;
    }
}

.info-label {
    font-size: 10px;
    font-weight: 600;
    color: #9E9E9E;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 3px;
}

.info-value {
    color: #2C3E50;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.4;
}

.package-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    border-bottom: 1px solid #F0F0F0;
    transition: background-color 0.2s;

    &:hover {
        background-color: #F8F9FA;
    }

    &:last-child {
        border-bottom: none;
    }
}

.package-name {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #2C3E50;
    font-weight: 500;
}

.package-price {
    font-size: 15px;
    font-weight: 700;
}

.notes-container {
    max-height: 250px;
    overflow-y: auto;
    padding: 4px;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C4C4C4;
        border-radius: 10px;

        &:hover {
            background: #A0A0A0;
        }
    }
}

.no-notes {
    text-align: center;
    padding: 24px;
    color: #999;
    font-size: 13px;
    font-style: italic;
}

.note-item {
    background-color: white;
    border: 1px solid #E0E0E0;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 8px;
    transition: box-shadow 0.2s, border-color 0.2s;

    &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        border-color: #C0C0C0;
    }

    &:last-child {
        margin-bottom: 0;
    }
}

.note-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
}

.note-meta {
    display: flex;
    gap: 2px;
}

.note-date {
    font-size: 10px;
    color: #999;
    font-weight: 500;
}

.note-author {
    font-size: 11px;
    color: #3498DB;
    font-weight: 600;
}

.note-content {
    font-size: 13px;
    color: #2C3E50;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
}

:deep(.custom-text-field) {
    legend {
        display: none;
    }

    fieldset {
        border-color: #D3D3D3 !important;
    }

    input {
        color: #101010;
        font-family: Manrope;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }
}

:deep(.v-data-table__empty-wrapper) {
    display: none;
}

:deep(.payment-type td) {
    height: 50px !important;
    border: none !important;
    font-weight: bold;
}

:deep(.small-row td) {
    height: 25px !important;
    border: none !important;
}

.event-status-select {
    :deep(.v-input__control) {
        min-height: 32px !important;
    }

    :deep(.v-select__selection) {
        margin: 0 !important;
    }

    :deep(.v-input__slot) {
        padding: 0px !important;
        min-height: 32px !important;
        border-color: transparent !important;
        background: transparent !important;
    }

    :deep(.v-input__slot:before) {
        display: none !important;
        border: none !important;
    }

    :deep(.v-input__slot:after) {
        display: none !important;
        border: none !important;
    }

    :deep(fieldset) {
        border: none !important;
    }

    :deep(.v-text-field__details) {
        display: none !important;
    }
}

.contributor-select {
    :deep(.v-input__slot:before) {
        display: none !important;
        border: none !important;
    }

    :deep(.v-input__slot:after) {
        display: none !important;
        border: none !important;
    }
}
</style>